<template>
  <cso-dialog ref="dialog"
      :header="$t('general.versionUpdate.title')"
      :hide-close-button="true"
      custom-class="version-update-modal">
    <div class="version-update-modal-content">
      <p>{{ $t('general.versionUpdate.text') }}</p>
      <cso-button :label="$t('general.versionUpdate.button')"
                  tabindex="0"
                  @click="reload" />
    </div>
  </cso-dialog>
</template>

<script>
import CsoDialog from '@/components/core/composition/CsoDialog.vue'
import VersionService from '@/common/VersionService'

export default {
  name: 'CsoVersionUpdatePopup',

  components: {
    CsoDialog
  },

  data () {
    return {
      unsubscribe: null
    }
  },

  mounted () {
    this.unsubscribe = VersionService.subscribe(() => this.openDialog())
  },

  beforeUnmount () {
    this.unsubscribe?.()
  },

  methods: {
    openDialog () {
      this.$refs.dialog.open()
    },

    reload () {
      return VersionService.reload()
    }
  }
}
</script>

<style lang="scss">
.version-update-modal {
  .sweet-modal .sweet-title {
    height: auto !important;
    white-space: normal;

    h2 {
      white-space: normal;
      overflow: visible;
      padding-bottom: 20px;
      text-align: center;
    }
  }

  p {
    font-family: 'VattenfallHall-Regular';
    font-size: 18px;
    line-height: 125%;
    margin-bottom: 40px;
  }

  .button {
    display: block;
    margin: 0 auto;
  }
}
</style>